import React from 'react';
import { Award, CheckCircle2 } from 'lucide-react';
import { aboutData } from '../data/mock';
import { videos } from '../data/videos';
import YouTubeEmbed from './YouTubeEmbed';
import InstitutesMarquee from './InstitutesMarquee';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="section-container">
        <div className="about-grid">
          <div className="about-image-wrapper">
            <img 
              src={aboutData.image}
              alt={aboutData.name}
              className="about-image"
              width="805"
              height="1000"
              loading="lazy"
              decoding="async"
            />
            <div className="about-badge">
              <Award className="w-6 h-6" />
              <span>Specialist TMD Physiotherapist</span>
            </div>
          </div>

          <div className="about-content">
            <h2 className="section-title">Meet {aboutData.name}</h2>
            <p className="about-bio">{aboutData.bio}</p>

            <div className="credentials">
              <h3 className="credentials-title">Qualifications &amp; Expertise</h3>
              {aboutData.credentialGroups ? (
                aboutData.credentialGroups.map((group) => (
                  <div key={group.title} className="credentials-group">
                    <h4 className="credentials-group-title">{group.title}</h4>
                    <ul className="credentials-list">
                      {group.items.map((credential) => (
                        <li key={credential} className="credential-item">
                          <CheckCircle2 className="credential-icon" size={18} />
                          <span>{credential}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))
              ) : (
                <ul className="credentials-list">
                  {aboutData.credentials.map((credential) => (
                    <li key={credential} className="credential-item">
                      <CheckCircle2 className="credential-icon" size={20} />
                      <span>{credential}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="about-highlight">
              <p>
                &ldquo;My approach is rooted in understanding the whole person, not just treating symptoms. 
                Every patient receives a personalized treatment plan designed to achieve lasting results.&rdquo;
              </p>
            </div>
          </div>
        </div>

        <InstitutesMarquee />

        <div className="about-video-row">
          <YouTubeEmbed
            youtubeId={videos.aboutKrina.youtubeId}
            title={videos.aboutKrina.title}
            description={videos.aboutKrina.description}
            variant="card"
          />
        </div>
      </div>
    </section>
  );
};

export default About;
